// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__RzH02","layout-container":"Footer_layout-container__tIewH","footerContainer":"Footer_footerContainer__Prdqx","footerLinks":"Footer_footerLinks__8IxyH","footerCopyright":"Footer_footerCopyright__FzJsT"};
    if(module.hot) {
      // 1763446807621
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  